<template>
  <app-layout>
    <template #header>
      <div class="flex items-center">
        <div class="flex-1">
          <h1 class="text-lg">
            Create System Admin
          </h1>
        </div>
        <div class="ml-6 self-center">
          <a
            :href="route('users.index')"
            class="transition-all transition-normal inline-flex items-center px-4 py-3 border-2 border-grey-300 text-grey-800 shadow text-sm font-semibold bg-white hover:bg-gray-50 focus:outline-none focus:shadow-outline no-underline hover:bg-primary-100 hover:border-primary-300 leading-none"
          >
            All Users
          </a>
        </div>
      </div>
    </template>
    <div class="container max-w-lg mt-8">
      <form class="profile" novalidate @submit.prevent="register">
        <div class="bg-white p-6 shadow-lg">
          <p class="text-xs italic">
            All fields are required for registration.
          </p>
          <auth-input
            v-model="auth.name"
            label="Name"
            input-type="text"
            :error="getError('name')"
            placeholder="Your Name"
            :loading="loading"
            :autocomplete="true"
          />

          <auth-input
            v-model="auth.job_title"
            label="Job Title"
            input-type="text"
            :error="getError('job_title')"
            placeholder="Your Job Title"
            :loading="loading"
            :autocomplete="true"
          />

          <auth-input
            v-model="auth.email"
            label="Email"
            input-type="email"
            :error="getError('email')"
            placeholder="e.g. your.name@email.com"
            :loading="loading"
            :autocomplete="true"
          />

          <auth-input
            v-model="auth.telephone"
            label="Telephone"
            input-type="tel"
            :error="getError('telephone')"
            placeholder="e.g. 02476 528 700"
            :loading="loading"
            :autocomplete="true"
          />

          <div class="pt-4 pb-6">
            <div class="text-center border-b border-grey-200">
              <p class="font-semibold -mb-3">
                <span class="bg-white px-3">Authentication</span>
              </p>
            </div>
          </div>

          <auth-input
            v-model="auth.password"
            label="Password"
            input-type="password"
            :error="getError('password')"
            placeholder="Your Password"
            :loading="loading"
            :autocomplete="true"
          />
          <auth-input
            v-model="auth.password_confirmation"
            label="Confirm Password"
            input-type="password"
            :error="getError('password_confirmation')"
            placeholder="Confirm Password"
            :loading="loading"
          />
        </div>
        <div class="flex">
          <div class="w-1/3 md:w-48 mr-3 flex-grow-0">
            <app-button
              type="submit"
              colour="primary"
              class="mt-8 mb-4"
              :disabled="loading"
            >
              <span v-if="!loading">
                Create Admin
              </span>
              <span v-else>Registering...</span>
            </app-button>
          </div>
        </div>
      </form>
    </div>
  </app-layout>
</template>

<script>
import { requestMixin } from "../mixins/request";

export default {
  name: "Register",
  mixins: [requestMixin],
  data() {
    return {
      auth: {
        name: "",
        job_title: "",
        email: "",
        telephone: "",
        password: "",
        password_confirmation: ""
      },
      loading: false
    };
  },
  created() {
    document.title = `Create Admin :: ${document.title}`;
  },
  methods: {
    register() {
      if (confirm("Are you sure you want to add an admin to the system?")) {
        this.loading = true;
        return axios
          .post(route("users.new"), this.auth)
          .then(response => this.registerResponse(response))
          .catch(error => this.requestError(error))
          .then(() => (this.loading = false));
      }
    },
    registerResponse() {
      Turbolinks.visit(route("users.index"));
    }
  }
};
</script>
<style>
.profile .auth-input label {
  @apply bg-grey-100;
}
</style>
